import Apify from '@module/apify';

export default Apify({
  getTransfers: {
    path: '/api/v4/transfers',
    method: 'GET',
  },

  deleteTransfer: {
    path: '/api/v4/transfers/{transferId}',
    pathExt: true,
    method: 'DELETE',
  },

  deleteMultipleTransfers: {
    path: '/api/v4/transfers/batch',
    method: 'POST',
  },

  getTransfer: {
    path: '/api/v4/transfers/{transferId}',
    pathExt: true,
    method: 'GET',
  },

  updateTransfer: {
    path: '/api/v4/transfers/{transferId}',
    pathExt: true,
    method: 'PUT',
  },
});
